import { type ChangeEvent, ComponentProps } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';

import { Input } from '@/components/core/input';

import { DefaultFormField, FormFieldProps } from './default-form-field';

type TextFormFieldInputProps = Omit<ComponentProps<typeof Input>, 'onChange' | 'value'> & {
  onChange?: (event: ChangeEvent<HTMLInputElement>, previousValue: string) => void;
};

export function TextFormField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  control,
  name,
  disabled,
  label,
  description,
  hideError,
  onChange,
  ...props
}: FormFieldProps<TextFormFieldInputProps, TFieldValues, TName>) {
  return (
    <DefaultFormField
      control={control}
      name={name}
      label={label}
      description={description}
      hideError={hideError}
      disabled={disabled}
      render={({ field }) => {
        const previousValue = field.value?.toString() ?? '';

        return (
          <Input
            {...field}
            {...props}
            value={previousValue}
            onChange={(event) => {
              field.onChange(event);
              onChange?.(event, previousValue);
            }}
          />
        );
      }}
    />
  );
}
